import React from 'react';
import { useSelector } from 'react-redux';
import { Col } from 'reactstrap';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { HomeOutlined } from '@mui/icons-material';

import { Breadcrumb, StyledRow } from './styles';
import { ClientNavLink } from './Layout/Client';

export function SubHeader(props) {
	const { breadcrumb } = props;
	const { user } = useSelector((state) => state.auth);
	const layout = useSelector((state) => state.layout);
	let redirectTo = '/client/transacoes';

	function redirectHome(){
		if (user.dados.permissoes.view_dashboard) {
			redirectTo = '/client/dashboard';
		}else{
			redirectTo = user.dados.permissoes.view_conciliacao ? '/client/dashboard' : '/client/transacoes';
		}

		return redirectTo;
	}

	return (
		<div className="d-none d-sm-none d-md-none d-lg-block">
			<StyledRow className="my-3 mr-0">
				<Col md="5">
					<Breadcrumb>
						<>
							<Link
								to={redirectHome()}
								className="d-flex align-items-center">
								<HomeOutlined className="mr-1" />
								Home
							</Link>

							{breadcrumb.map((item) => {
								return (
									<Link
										key={item.link}
										to={item.link}
										className="d-flex align-items-center">
										{item.page}
									</Link>
								);
							})}
						</>
					</Breadcrumb>
				</Col>
				<Col md="7 pr-0">
					<div className="d-flex justify-content-end" style={{ alignItems: 'center' }}>
						{layout.tipo === 'client' && <ClientNavLink />}
					</div>
				</Col>
			</StyledRow>
		</div>
	);
}

SubHeader.propTypes = {
	breadcrumb: PropTypes.oneOfType([PropTypes.any]),
};

SubHeader.defaultProps = {
	breadcrumb: [],
};
